import $ from 'jquery';
import 'slick-carousel';

function numberDots($slider) {
  const $dots = $slider.find('.slick-dots');
  if (!$dots.length) return;

  $dots.find('li').each((i, li) => {
    $(li).find('button').text(String(i + 1).padStart(2, '0'));
  });
}

$(document).ready(() => {
  const $sliders = $('.intro-text-element-tile-view.js-slider');
  if (!$sliders.length) return;

  $sliders.each((_, el) => {
    const $slider = $(el);
    if ($slider.hasClass('slick-initialized')) return;

    $slider.on('init', (_, slick) => {
      numberDots($(slick.$slider));
    });

    $slider.on('setPosition', (_, slick) => {
      numberDots($(slick.$slider));
    });

    $slider.slick({
      dots: true,
      arrows: false,
      infinite: false,
      adaptiveHeight: true,
    });
  });
});
